@let isFiltered = isFiltered$ | async;
<button
  [disabled]="!isFiltered"
  nzBlock
  nz-button
  nzType="default"
  type="button"
  class="fw-normal w-100 rounded-1"
  (click)="resetAllQueryParams()"
  data-test-id="clear-timeline-filters-button:button"
>
  {{ 'general.clearAllFilter' | translate }}
</button>
